import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6d8a5f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-image-viewer-mobile" }
const _hoisted_2 = { class: "has-text-modest" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "has-text-modest" }
const _hoisted_5 = { class: "has-text-modest" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", null, [
      _createElementVNode("dt", _hoisted_2, _toDisplayString(_ctx.$t('label.help.viewer.sendPage')), 1),
      _createElementVNode("dd", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('label.help.viewer.flickWithOneFinger')) + " ", 1),
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('label.help.viewer.tappingLeftAndRight')), 1)
      ]),
      _createElementVNode("dt", _hoisted_4, _toDisplayString(_ctx.$t('label.help.viewer.moveImage')), 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.$t('label.help.viewer.swipeWithTwoFinger')), 1),
      _createElementVNode("dt", _hoisted_5, _toDisplayString(_ctx.$t('label.help.viewer.watchIndices')), 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.$t('label.help.viewer.tappingClose')), 1)
    ])
  ]))
}